import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import {TriggerLoginLegacySync} from './global/TriggerLoginLegacySync/TriggerLoginLegacySync';

interface LegacyAuthSyncContextType {
  handleOnSyncLegacy?: VoidFunction;
}

const LegacyAuthSyncContext = createContext<LegacyAuthSyncContextType | null>(
  null,
);

const useLegacyAuthSyncContext = (): LegacyAuthSyncContextType => {
  const legacyAuthSyncContext = useContext(LegacyAuthSyncContext);
  if (!legacyAuthSyncContext) {
    throw new Error(
      'Cannot find LegacyAuthSyncContext value, did you forget adding LegacyAuthSyncProvider?',
    );
  }

  return legacyAuthSyncContext;
};

export const useHandleOnSyncLegacy = () => {
  return useLegacyAuthSyncContext().handleOnSyncLegacy;
};

export const LegacyAuthSyncProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [shouldSync, setShouldSync] = useState(false);

  const handleNeedToSyncLegacy = useCallback(() => {
    setShouldSync(true);
  }, []);

  const handleLegacySyncDone = () => {
    setShouldSync(false);
  };

  const value = useMemo(() => {
    return {
      handleOnSyncLegacy: handleNeedToSyncLegacy,
    };
  }, [handleNeedToSyncLegacy]);

  return (
    <LegacyAuthSyncContext.Provider value={value}>
      {children}
      {shouldSync ? (
        <TriggerLoginLegacySync onSyncDone={handleLegacySyncDone} />
      ) : null}
    </LegacyAuthSyncContext.Provider>
  );
};
